import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentIntegrationConnector on IntgConnector {
    id
    name
    definitionId
    baseUrl
    lastRun {
      id
      startedAt
      completedAt
      error
      imports { path status error }
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.custom<
  graphql.schema.FragmentIntegrationConnectorFragment,
  ents.core.integrations.Connector
>(connector => ({
  baseUrl: connector.baseUrl,
  definitionId: connector.definitionId,
  id: connector.id,
  lastRun: connector.lastRun
    ? {
        completedAt: connector.lastRun.completedAt ?? undefined,
        error: connector.lastRun.error ?? undefined,
        id: connector.lastRun.id,
        imports: connector.lastRun.imports.map(importRun => ({
          error: importRun.error ?? undefined,
          path: importRun.path,
          status: importRun.status as ents.core.integrations.Connector.Run.Import.Status,
        })),
        startedAt: connector.lastRun.startedAt,
      }
    : undefined,
  name: connector.name,
}))
